import { Injectable } from '@angular/core';
import { Subject, Observable, BehaviorSubject } from 'rxjs';
import { LogService } from '../log/log.service';
import { Session } from './session.models';
import { StoreService } from '../store/store.service';
import { HttpClient } from '@angular/common/http';
import { ConfigurationService } from '../conf/configuration.service';
import { ProductApi } from '../../../../environments/public-conf.models';
import { map, tap } from "rxjs/operators";

export interface Credentials {
	email: string;
	password: string;
}

@Injectable()
export class SessionService {
	public static readonly sessionKey: string = 'session';

	public session$: BehaviorSubject<Session> = new BehaviorSubject(null);
	public islogged$: Observable<boolean> = this.session$.pipe(map((p) => !!p));
	public login$: Observable<any> = new Subject();
	public logout$: Observable<any> = new Subject();

	private products: ProductApi[];
	private baseHref: string;

	public constructor(
		private logService: LogService,
		private store: StoreService,
		private http: HttpClient,
		private conf: ConfigurationService
	) {
		this.baseHref = this.conf.getAsString('api.baseHref');
	}

	public load(): void {
		const session: Session = this.store.get(SessionService.sessionKey);
		if (!session) return;
		(this.logout$ as Subject<any>).next(null);
		this.openSession(session);
	}

	public login(credentials: Credentials): Observable<any> {
		return this.http
			.post('/backoffice/auth/login', credentials)
			.pipe(tap(
				(res) => {
					this.openSession(res as Session);
					(this.login$ as Subject<any>).next(null);
					return res as Session;
				}
			));
	}

	public logout(): void {
		this.closeSession();
		(this.logout$ as Subject<any>).next(null);
	}

	public openSession(session: Session): void {
		this.store.set(SessionService.sessionKey, session);
		this.session$.next(session);
		(this.login$ as Subject<any>).next(null);
	}

	public isTokenValid(): boolean {
		if (!this.session$.getValue()) {
			return false;
		}

		const session = this.session$.getValue();

		if (!session.token) {
			return false;
		}
		return true;
	}

	private closeSession(): void {
		this.store.del(SessionService.sessionKey);
		this.session$.next(null);
	}
}
